import React from 'react';
import { SvgIcon, styled } from '@nextiva/next-ui-components';

const StyledIcon = styled(SvgIcon)`
  transform: ${({ toggle }) => (toggle ? 'rotate(-180deg)' : 'rotate(0deg)')};
  transition: all 0.2s;
  margin: 0 0 0 0.5rem;
  &.MuiSvgIcon-root {
    width: 11px;
    height: 10px;
  }
`;

export const SvgOpenClose = (props) => {
  return (
    <StyledIcon viewBox="0 0 11.289 7.854" {...props}>
      <path
        id="Shape"
        d="M9.031,7.854,5.645,4.488,2.258,7.854,0,5.61,5.645,0l5.645,5.61Z"
        transform="translate(11.289 7.854) rotate(180)"
        fill="#758BA3"
      />
    </StyledIcon>
  );
};
